module.exports = __webpack_public_path__ + "img/swiper3.5b444381.jpg";